import { useCallback, useEffect, useState } from "react";
import useHttpHook from "../../Hooks/HttpHook";
import { OrganizerEventApi } from "../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../utils/Helper";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import Event from "./Event";
import MainPagination from "../Common/MainPagination";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const statuses = [
  { name: "cancelled", label: "Cancelled" },
  { name: "expired", label: "Expired" },
  { name: "draft", label: "Draft" },
  { name: "upcoming", label: "Upcoming" },
  { name: "active", label: "Active" },
];

const MyEvents = () => {
  const [loading, sendRequest, error] = useHttpHook();
  const [eventsList, setEventsList] = useState();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);
  const queryStatus = query.get("status");
  const querySearch = query.get("search");

  const getEvents = useCallback(
    async (page = 1) => {
      const events = await sendRequest(
        `${OrganizerEventApi}?page=${page}&search=${
          querySearch ? querySearch : ""
        }&status=${queryStatus ? queryStatus : ""}`,
        {
          method: "get",
        }
      );
      if (page == 1) {
        setEventsList(events);
      } else {
        setEventsList((prevState) =>
          createObjectForPaginatedResult(events, prevState)
        );
      }
    },
    [queryStatus, querySearch]
  );

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  useEffect(() => {
    if (querySearch) {
      setSearch(querySearch);
    }
    if (queryStatus) {
      setStatus(queryStatus);
    }
  }, [queryStatus, querySearch]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const handleFilterSubmit = (event) => {
    event.preventDefault();
    navigate(`/organizer/MyEvents?status=${status}&search=${search}`);
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <form
        className="event-created-filters"
        id="eventCreatedFilterForm"
        onSubmit={handleFilterSubmit}
      >
        <div className="event-created-filter-field">
          <label htmlFor="eventCreatedFilterName">Event Name</label>
          <input
            className="event-created-filter-input"
            type="text"
            id="eventCreatedFilterName"
            name="eventName"
            placeholder="Event Name"
            autoComplete="off"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="event-created-filter-field">
          <label htmlFor="eventCreatedFilterStatus">Event</label>
          <select
            className="event-created-filter-select"
            id="eventCreatedFilterStatus"
            name="eventStatus"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">Please select</option>
            {statuses.map((item) => (
              <option key={item.name} value={item.name}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
        <button
          className="event-created-filter-submit"
          type="submit"
          disabled={loading}
        >
          Submit
        </button>
      </form>

      {eventsList?.data?.itemsList?.length ? (
        <MainPagination getEventsMethod={getEvents} MainData={eventsList}>
          <div className="event-created-grid" role="list" aria-label="Created events list">
            {eventsList.data.itemsList.map(
              ({
                _id,
                title,
                eventTiming,
                description,
                mainimage,
                isActive,
                category,
                ticketType,
                isCancelled,
              }) => (
                <Event
                  key={_id}
                  title={title}
                  eventTiming={eventTiming}
                  Id={_id}
                  description={description}
                  mainimage={mainimage}
                  getEvents={getEvents}
                  category={category}
                  isActive={isActive}
                  ticketType={ticketType}
                  isCancelled={isCancelled}
                />
              )
            )}
          </div>
        </MainPagination>
      ) : eventsList ? (
        <div className="event-empty">
          <i className="bi bi-calendar-x" aria-hidden="true"></i>
          <p>No events found</p>
        </div>
      ) : null}
    </MainComponentWrapper>
  );
};

export default MyEvents;
